import {ListItem} from '../../../../../categorization/utils';

export interface ListItemsExtended extends ListItem {
  documentCount: number | null;
}
export const treeDataSourceSelection = (
  items: any = []
): ListItemsExtended[] => {
  const map = new Map<string, ListItemsExtended>();
  const roots: ListItemsExtended[] = [];

  for (const item of items) {
    const id = String(item.id);
    const parent = item.parent != null ? String(item.parent) : null;

    map.set(id, {
      id,
      label: getLabelFromText(item.text),
      documentCount: getCountFromText(item.text),
      parent,
      text: item.text ?? id,
      children: [],
      skipParent: item.isGroup ?? false,
    });
  }

  for (const item of items) {
    const id = String(item.id);
    const parent = item.parent != null ? String(item.parent) : null;
    const node = map.get(id);
    if (!node) continue;

    if (parent && parent !== '#' && map.has(parent)) {
      map.get(parent)!.skipParent = true;
      map.get(parent)!.children!.push(node);
    } else {
      roots.push(node);
    }
  }

  return roots;
};

const getLabelFromText = (text = '') => {
  return String(text).replace(/\s{0,20}\(\d{1,10}\)\s{0,20}$/, '');
};

const getCountFromText = (text = '') => {
  const match = text.match(/\((\d+)\)/);
  return match ? Number(match[1]) : null;
};
